import { ModuleConfig } from "@core/interfaces";

const config: ModuleConfig = {
  name: "SignUp",
  baseUrl: "",
  routes: [
    {
      path: "/admin/sign-up",
      page: "SignUpWare",
      title: "Sign Up Page",
      exact: true,
    },
  ],
  requireAuthenticated: false,
};

export default config;
